import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"search\"><path fill=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"m20.296 22-6.883-6.884a7.226 7.226 0 1 1 .479-11.41 7.225 7.225 0 0 1 1.225 9.706L22 20.296l-1.703 1.703zM9.226 4.41a4.817 4.817 0 1 0 3.513 1.521l.728.723-.821-.819-.014-.014a4.78 4.78 0 0 0-3.406-1.412Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol